module.exports = __webpack_public_path__ + "img/hacken.32efa74e.jpeg";